import { render } from "./Page2.vue?vue&type=template&id=ea46639e"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"

import "./Page2.vue?vue&type=style&index=0&id=ea46639e&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__